import ImportTemplateAPI from "../api/ImportTemplateAPI";
import EventRegistryAPI from "../plugins/eventRegistry/api/EventRegistryAPI";
import ContractAggregateAPI from "@/api/ContractAggregateAPI";
import DiscountRateAPI from "../plugins/discountRates/api/DiscountRateAPI";
import CounterpartiesAPI from "@/api/CounterpartiesAPI";
import AssetAPI from "@/api/AssetAPI";
export default {
  data() {
    return {
      url: null,
      linkAttribute: null,
    }
  },
  methods: {
    async downloadTemplate() {
      this.error = null;
      this.$fileLoadingManager.startLoading()
      try {
        let response = null;
        switch (this.importType){
          case 'manualChart': {
            const api = new EventRegistryAPI();
            response = await api.generateManualChartTemplate(this.manualChartsForDownload);
            break;
          }
          case 'contractsRegistry': {
            const api = new ContractAggregateAPI();
            response = await api.contractsRegistryExport(this.filterData);
            break;
          }
          case 'importContractsWithNewDiscountRates': {
            const api = new DiscountRateAPI();
            response = await api.contractsForRecalculationDownloadExcel(this.contractsWithNewDiscountRates);
            break;
          }
          case 'importInvalidValidationContracts': {
            const api = new ContractAggregateAPI();
            response = await api.getContractsFailedLessorSharesValidation();
            break;
          }
          case 'contractsWithMixedDiscountRateTypes': {
            const api = new DiscountRateAPI();
            const contracts = { contracts: this.contractsWithMixedDiscountRateTypes };
            response = await api.contractsForRecalculationDownloadExcel(contracts);
            break;
          }
          case 'editContractWithNewDiscountRate': {
            const api = new DiscountRateAPI();
            const contracts = { contracts: this.importContractsWithNewDiscountRates };
            response = await api.contractsForRecalculationDownloadExcel(contracts);
            break;
          }
          case 'contractsWithoutDiscountRate': {
            const api = new DiscountRateAPI();
            response = await api.contractsWithoutDiscountRate(this.contractsWithoutDiscountRate);
            break;
          }
          case 'contractsHasNonActiveStatus': {
            const api = new ContractAggregateAPI();
            response = await api.exportContractsHasNonActiveStatus(this.contractsHasNonActiveStatus);
            break;
          }
          case 'initialDataContracts': {
            const api = new ContractAggregateAPI();
            response = await api.initialDataContractsExport();
            break;
          }
          case 'allVatCounterparties': {
            const api = new CounterpartiesAPI();
            response = await api.downloadAllVatCounterparties();
            break;
          }
          case 'allAssets': {
            const api = new AssetAPI();
            response = await api.downloadAllAssets();
            break;
          }
          case 'allDiscountRates': {
            const api = new DiscountRateAPI();
            response = await api.downloadAllDiscountRates();
            break;
          }
          default: {
            const api = new ImportTemplateAPI();
            response = await api.generate(this.importType);
            break;
          }
        }

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
      this.$fileLoadingManager.finishLoading()
    }
  }
};
